import { BrowserRouter } from 'react-router-dom';

const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
};
import { ConfigProvider, App as AntdApp } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import AppRouter from './routes';
import { ToastContainer } from './components/common/Toast';
import { antdTheme } from './config/antd-theme';

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <AntdApp>
        <BrowserRouter {...routerConfig}>
          <AuthProvider>
            <AppProvider>
              <AppRouter />
              <ToastContainer position="top-right" />
            </AppProvider>
          </AuthProvider>
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;

